import { Handler } from "@insite/client-framework/HandlerCreator";
import { HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { CartResult, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, DispatchLoadPromotions } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ViewCart, ViewCheckout } from "@SupplyLand/Utilities/customTracking";

type HandlerType = Handler<
    {
        shouldLoadFullCart?: boolean;
        replaceCart?: boolean;
        getPromotions?: boolean;
        getCartLines?: boolean;
        getCostCodes?: boolean;
    } & HasOnSuccess,
    {
        apiParameter: GetCartApiParameter;
        apiResult: CartResult;
        needFullCart: boolean;
    }
>;

export const TrackCheckoutProcess: HandlerType = props => {
    const pageType = getCurrentPage(props.getState()).type;
    const cart = props.apiResult.cart;
    const billTo = props.apiResult.billTo;
    const shipTo = props.apiResult.shipTo;

    if (pageType === "CartPage") {
        ViewCart(cart);
    } else if (
        (pageType === "OnePageCheckoutPage" || pageType === "CheckoutReviewAndSubmitPage") &&
        cart.status === "Cart"
    ) {
        ViewCheckout(cart, billTo);
    }
};

addToChainAfter(chain, DispatchLoadPromotions, TrackCheckoutProcess);
